import React, { useContext, useState } from 'react';
import classes from '../index.module.scss';
import moment from 'moment';
import { useForm } from 'react-hook-form';
import { UserContext } from '../../../context/User';
import { ReactComponent as DeleteIcon } from '../../../assets/icons/not-check.svg';
import { ROLE_LIST } from '../../../constans';
import { deleteUserDelete } from '../../../api';
import { deleteUserNotice, somethingWentWrongNotice } from '../../UI/Notifications';
import { useHistory } from "react-router-dom";
import Modal from '../../UI/Modal';
import DeleteUserModalContent from '../../ModalContents/DeleteUserModalContent';

const RecentUsersTableBody = ({ list, searchTrigger, setSearchTrigger }) => {
  const { setIsLoggedIn, setUser } = useContext(UserContext);
  const history = useHistory();
  const [show, setShow] = useState(false);
  const { handleSubmit } = useForm();
  const [userId, setUserId] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  }  

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push("/");
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout();
    } else {
      somethingWentWrongNotice("Delete User");
    }
  }

  const onSubmit = () => {
    handleClose();
    deleteUserDelete({user_id: userId})
    .then(() => {
      setSearchTrigger(!searchTrigger);
      deleteUserNotice();
    })
    .catch(error => {
      handleDefaultStatusCodes(error.response.status);
    });
  }

  const deleteUserHandler = id => {
    handleShow();
    setUserId(id);
  }

  return (
    <>
      {
        list.map(item => { 
          const { id, registration_date, username, roles } = item;
          const role = roles[0].role_description;
          const registration = moment(registration_date).format('MM/DD/YYYY');

          return (
            <tr 
              key={id}
            >
              <td className={`${classes.Title_Normal} ${classes.Vertical_Middle}`}>
                <span 
                  className={`${role} general`}
                >
                  {ROLE_LIST[role]}
                </span>
              </td>
              <td className={`${classes.Title_Normal} ${classes.Vertical_Middle}`}>{username}</td>
              <td className={`${classes.Title_Normal} ${classes.Vertical_Middle}`}>{registration}</td>
              <td className={`${classes.Title_Normal} ${classes.Vertical_Middle} text-center`}>
                {<DeleteIcon 
                  onClick={() => deleteUserHandler(id)}
                  className={classes.Delete_Icon}
                />}
              </td>
            </tr>
          )
        })
      }
      <Modal 
        handleClose={handleClose} 
        show={show}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        buttonLabel="Delete"
      >
        <DeleteUserModalContent />
      </Modal>
    </>
  )
}

export default RecentUsersTableBody;